// extracted by mini-css-extract-plugin
module.exports = {"root":"zGruFrBfljIVefrwkS3i","crumb":"QBWk9V9mhzgm8gexVYmf"};